import React, { useState, useEffect } from "react";
import ProductCard from "../../components/ProductCards/index";

//Importing Material UI stuff
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Box, Typography } from "@material-ui/core";
//Importing Components
import { OutlinedButton } from "../../components/Buttons";

import style from "./style";
const useStyles = makeStyles(style);

const ProductsPage = ({ products }) => {
  const classes = useStyles();
  const [setIsDesktop] = useState(window.innerWidth > 900);
  const updateMedia = () => {
    setIsDesktop(window.innerWidth > 900);
  };

  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });
  return (
    <div className="page">
      <Typography data-aos="fade-in" variant="h2" className={classes.title}>
        Selected Products
      </Typography>
      <Typography data-aos="fade-in" variant="h6" gutterBottom className={classes.description}>
        High quality resources for developers and designers which will help them create beautiful applications and boost productivity.
      </Typography>
      <Grid className={classes.productsGrid}>
        <Box className={classes.cardSection}>
          <ProductCard data-aos="fade-in" data={products} />
        </Box>
        <Typography data-aos="fade-in" variant="h6" gutterBottom className={classes.centerPara}>
          Want amazing resources and code snippets to use in your future projects? You'll find them all on my GitHub, make sure to follow for more!
        </Typography>
        <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <a data-aos="fade-in" href="https://github.com/DevrajDC" target="_blank" rel="noreferrer" className="hover-detect">
            <OutlinedButton size="large">View GitHub</OutlinedButton>
          </a>
        </div>
      </Grid>

    </div>
  );
};

export default ProductsPage;
